"use strict";
/*
 * Created on Wed Oct 24 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * Converts attributes of {@link ApplicationConfiguration application configuration}
 *
 * @author RV
 */


var ApplicationConfigurationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ApplicationConfigurationConverter, _DataObjectConverter_);

  function ApplicationConfigurationConverter() {
    _classCallCheck(this, ApplicationConfigurationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApplicationConfigurationConverter).apply(this, arguments));
  }

  return ApplicationConfigurationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ApplicationConfigurationConverter = ApplicationConfigurationConverter;